<template>
  <div data-test-id="not-found-error" class="error-404">
    <div class="error-404__content">
      <div class="error-404__image-container">
        <nuxt-img
          class="error-404__image"
          src="/error-not-found.png"
          alt="Страница не найдена"
        />
      </div>

      <div class="error-404__text">Страница не найдена</div>

      <the-button block variant="tertiary" class="error-404__button" href="/">
        На главную
      </the-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error-404 {
  height: 100vh;
  text-align: center;
  border: 1px solid transparent;

  &__content {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-items: flex-start;
    margin: 100px 0 0;
  }

  &__image-container {
    width: 100%;
    max-width: 522px;
    filter: drop-shadow(0 40px 100px rgba(0, 0, 0, 0.2));
  }

  &__image {
    width: 100%;
  }

  &__text {
    margin-top: 100px;
    font-size: 20px;
    font-weight: 600;
    line-height: 23px;
    color: var(--ui-dark-grey);

    @include media('>=desktop-mini') {
      margin-top: 50px;
      font-weight: 500;
    }
  }

  &__button {
    width: 200px;
    margin: 40px auto 0;
  }
}
</style>
